import { OrderFulfillmentStatus, OrderMethod } from '../../../../../services/exports/Constants';

export default {
  header: 'Historique des commandes',
  labels: {
    dummy_order: 'Commande test',
    orders_number: 'Nombre de commandes ({{count}})',
    revenue: "Chiffre d'affaires : {{amount}}",
    tips: 'Pourboires : {{amount}}',
    cash_sales: ' ({{amount}} Espèces)',
    refunds: 'Remboursements : {{count}} ({{amount}})',
  },
  order_methods: {
    [OrderMethod.Pickup]: 'À emporter',
    [OrderMethod.Delivery]: 'Livraison',
    [OrderMethod.OnSite]: 'Commande à table',
  },
  statuses: {
    [OrderFulfillmentStatus.Created]: 'En cours',
    [OrderFulfillmentStatus.Reviewed]: 'En cours',
    [OrderFulfillmentStatus.Accepted]: 'En cours',
    [OrderFulfillmentStatus.Preparing]: 'En cours',
    [OrderFulfillmentStatus.Ready]: 'En cours',
    [OrderFulfillmentStatus.OnDelivery]: 'En cours',
    [OrderFulfillmentStatus.Picked]: 'Terminé',
    [OrderFulfillmentStatus.Rejected]: 'Refusé',
  },
  payment_methods: {
    invoice: 'Facture',
    cash: 'Espèces',
    online: 'Méthode en ligne',
  },
  filters: {
    all: 'Tous',
  },
  fields: {
    order_placed: 'Commande passée',
    order_number: '#',
    customer: 'Client',
    payment_method: 'Mode de paiement',
    method: 'Type',
    status: 'Statut',
    total: 'Total',
  },
  buttons: {
    print: 'Imprimer',
    create_test_order: 'Créer une commande test',
  },
  toasts: {
    failed_to_fetch_orders:
      "Échec du chargement des données. Cliquez sur l'icône « actualiser » ou réessayez dans 1 minute.",
    something_went_wrong: 'Une erreur est survenue, veuillez réessayer.',
    failed_to_create_test_order: 'Échec de la création de la commande test',
    test_order_created: 'Commande test créée',
  },
};
